import './testOrderAttachmentsEditComponent.scss'
import React, {useCallback, useEffect, useRef, useState} from 'react';
import InputComponent from "../../../../../shared/components/core/input/InputComponent";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";
import {CommonService} from "../../../../../shared/services";
import AttachmentViewDownloadComponent
    from "../../../../../shared/components/core/attachment-view-download/attachmentViewDownloadComponent";
import FeedbackComponent from "../../../../../shared/components/feedback/feedbackComponent";
import DialogComponent from "../../../../../shared/components/dialog/dialogComponent";
import FilePreviewerComponent from "../../../../../shared/components/file-previewer/filePreviewerComponent";
import PdfPreviewComponent from "../../../../../shared/components/pdf-preview/pdfPreviewComponent";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import _ from "lodash";
import {ImageConfig} from "../../../../../constants";
import {Grid} from "@material-ui/core";
import ErrorComponent from "../../../../../shared/components/form-controls/error/errorComponent";

interface TestOrderAttachmentsEditComponentProps {
    testOrderAttachments: any;
    onUpdateComplete: Function;
    testOrderID: number;
    onEditCancel:Function;
}

const TestOrderAttachmentsEditComponent = (props: TestOrderAttachmentsEditComponentProps) => {
        const {testOrderAttachments, onUpdateComplete, testOrderID,onEditCancel} = props;
        const [orderAttachmentList, setOrderAttachmentList] = useState<any[]>(testOrderAttachments?.order);

        const [patientAttachmentList, setPatientAttachmentList] = useState<any[]>(testOrderAttachments?.patient);

        const [orderAttachmentFile, setOrderAttachmentFile] = useState<any>(undefined);
        const [orderAttachmentTitle, setOrderAttachmentTitle] = useState<string>("");

        const [patientAttachmentFile, setPatientAttachmentFile] = useState<File | undefined>(undefined);
        const [patientAttachmentTitle, setPatientAttachmentTitle] = useState<string>("");

        const patientAttachmentFileRef = useRef<HTMLInputElement | null>(null);
        const orderAttachmentFileRef = useRef<HTMLInputElement | null>(null);
        const [showPatientAttachmentPreviewDialog, setShowPatientAttachmentPreviewDialog] = useState<boolean>(false);
        const [showOrderAttachmentPreviewDialog, setShowOrderAttachmentPreviewDialog] = useState<boolean>(false);
        const [isNewPatientAttachment, setNewPatientAttachment] = useState<boolean>(false)
        const [isNewOrderAttachment, setNewOrderAttachment] = useState<boolean>(false)
        const [isContinueVisible, setIsContinueVisible] = useState<boolean>(false);
        const [isOrderAttachmentBeingUploaded, setIsOrderAttachmentBeingUploaded] = useState<boolean>(false);
        const [isPatientAttachmentBeingUploaded, setIsPatientAttachmentBeingUploaded] = useState<boolean>(false);
        const [isEdited, setIsEdited] = useState<boolean>(false)
        const [isSaveButtonEnable, setIsSaveButtonEnable] = useState<boolean>(false)

        const handleOrderAttachmentSuccess = useCallback((response: any) => {
            CommonService._alert.showToast(response?.message || 'Added Order Attachments', "success");
            setOrderAttachmentList((oldState: any) => {
                if (oldState?.length > 0) {
                    return [response.data, ...oldState]
                } else {
                    return [response.data]
                }
            });
            setIsOrderAttachmentBeingUploaded(false);
            setOrderAttachmentFile(undefined);
            setOrderAttachmentTitle("");
        }, []);

        const handlePatientAttachmentSuccess = useCallback((response: any) => {
            CommonService._alert.showToast(response?.message || 'Added Patient Attachments', "success");
            setPatientAttachmentList((oldState: any) => {
                if (oldState?.length > 0) {
                    return [response.data, ...oldState]
                } else {
                    return [response.data]
                }
            })
            setIsPatientAttachmentBeingUploaded(false);
            setPatientAttachmentFile(undefined);
            setPatientAttachmentTitle("");
        }, []);

        const onOrderAttachmentSubmit = useCallback(() => {
            const formData = new FormData();
            if (orderAttachmentFile) {
                formData.append('image', orderAttachmentFile);
                formData.append('attachmentType', 'order')
            }
            formData.append('title', orderAttachmentTitle);
            setIsOrderAttachmentBeingUploaded(true);
            CommonService._testOrder.uploadOrderAttachments(testOrderID, formData)
                .then((response: IAPIResponseType<any>) => {
                    handleOrderAttachmentSuccess(response);
                    setIsEdited(true);
                    setShowOrderAttachmentPreviewDialog(false);
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error uploading order attachment', "error");
                    setIsOrderAttachmentBeingUploaded(false);
                })
        }, [orderAttachmentFile, handleOrderAttachmentSuccess, orderAttachmentTitle, testOrderID]);

        const onPatientAttachmentSubmit = useCallback(() => {
            const formData = new FormData();
            if (patientAttachmentFile) {
                formData.append('image', patientAttachmentFile);
                formData.append('attachmentType', 'patient')
            }
            formData.append('title', patientAttachmentTitle);
            setIsPatientAttachmentBeingUploaded(true);
            CommonService._testOrder.uploadPatientAttachments(testOrderID, formData)
                .then((response: IAPIResponseType<any>) => {
                    handlePatientAttachmentSuccess(response);
                    setIsEdited(true);
                    setShowPatientAttachmentPreviewDialog(false);
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error uploading order attachment', "error");
                    setIsPatientAttachmentBeingUploaded(false);
                })
        }, [patientAttachmentFile, handlePatientAttachmentSuccess, patientAttachmentTitle, testOrderID]);

        const removeOrderAttachment = useCallback((attachmentId: any) => {
            const payload = {};
            CommonService._testOrder.deleteTestOrderAttachment(testOrderID, attachmentId, payload)
                .then((response: IAPIResponseType<any>) => {
                    CommonService._alert.showToast(response?.message || 'Order attachment has been removed', "success");
                    setIsEdited(true);
                    setOrderAttachmentList((oldState: any) => {
                        const updatedList = _.cloneDeep(oldState);
                        const index = updatedList.findIndex((item: any) => item.id === attachmentId);
                        updatedList.splice(index, 1);
                        return updatedList;
                    });
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error deleting order attachment', "error");
                })
        }, [testOrderID]);

        const removePatientAttachment = useCallback((attachmentId: any) => {
            const payload = {};
            CommonService._testOrder.deleteTestOrderPatientAttachment(testOrderID, attachmentId, payload)
                .then((response: IAPIResponseType<any>) => {
                    CommonService._alert.showToast(response?.message || 'Patient attachment has been removed', "success");
                    setIsEdited(true);
                    setPatientAttachmentList((oldState: any) => {
                        const updatedList = _.cloneDeep(oldState);
                        const index = updatedList.findIndex((item: any) => item.id === attachmentId);
                        updatedList.splice(index, 1);
                        return updatedList;
                    })
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error deleting patient attachment', "error");
                })
        }, [testOrderID]);


        const handleAttachmentRemove = useCallback((id: any, type: any) => {
            CommonService.openConfirmationDialog({
                confirmationTitle: 'Please confirm!',
                confirmationSubTitle: 'Are you sure you want to delete this attachment?',
                disableEscKeyClose: false,
                disableBackdropClose: true,
                imagePath: `${ImageConfig.DeleteImage}`,
                direction: "up",
                yes: {
                    text: "Confirm",
                    color: "primary"
                },
                no: {
                    text: "Cancel",
                    color: "primary"
                }
            })
                .then(() => {
                    if (type === 'order') {
                        removeOrderAttachment(id);
                    } else {
                        removePatientAttachment(id);
                    }
                })
                .catch(() => {
                })
        }, [removeOrderAttachment, removePatientAttachment]);


        const handlePatientAttachmentUpload = useCallback((event: any) => {
            const file = event?.target?.files[0];
            const maxAllowedSize = 5 * 1024 * 1024;
            if (event?.target?.files[0].size > maxAllowedSize) {
                CommonService._alert.showToast('File size should be under 5MB.', "error");
                event.target.value = '';
                return;
            }
            event.target.value = null;
            event.target.files = null;
            setIsContinueVisible(true);
            setShowPatientAttachmentPreviewDialog(true);
            setPatientAttachmentFile(file);
            setNewPatientAttachment(true);
        }, []);

        const handleOrderAttachmentUpload = useCallback((event: any) => {
            const file = event?.target?.files[0];
            const maxAllowedSize = 5 * 1024 * 1024;
            if (event?.target?.files[0].size > maxAllowedSize) {
                CommonService._alert.showToast('File size should be under 5MB.', "error");
                event.target.value = '';
                return;
            }
            event.target.value = null;
            event.target.files = null;
            setIsContinueVisible(true);
            setShowOrderAttachmentPreviewDialog(true);
            setOrderAttachmentFile(file);
            setNewOrderAttachment(true);
        }, []);

        useEffect(() => {
            if (patientAttachmentList?.length > 0 || orderAttachmentList?.length > 0) {
                if (isEdited) {
                    setIsSaveButtonEnable(true)
                } else {
                    setIsSaveButtonEnable(false)
                }
            } else {
                setIsSaveButtonEnable(false)
            }

        }, [patientAttachmentList, orderAttachmentList,isEdited]);

        return (
            <div className="test-order-attachment-screen ">
                <div className="t-form attachments-with-title-wrapper">
                    <form>
                        <div className="t-form-controls-wrapper overflow-hidden">
                            <div className="attachment-section-header">Order Attachments</div>
                            <div className="attachment-input-wrapper">
                                <div className={'attachment-input-section'}>
                                    <InputComponent
                                        type={"text"}
                                        name={"title"}
                                        label={"Attachment Name"}
                                        placeholder={"Enter Attachment Name"}
                                        value={orderAttachmentTitle}
                                        fullWidth={true}
                                        onChange={(value: any) => {
                                            setOrderAttachmentTitle(value.replace(/\s/g, ''));
                                        }}
                                    />
                                    {
                                        orderAttachmentTitle.length > 100 &&
                                        <ErrorComponent errorText={'Attachment name should be less than 100 characters'}/>
                                    }
                                </div>
                                <input type={"file"}
                                       className={"display-none"}
                                       ref={orderAttachmentFileRef}
                                       accept={"image/jpeg,image/gif,image/png,application/pdf,image/x-eps"}
                                       onChange={(event) => {
                                           handleOrderAttachmentUpload(event);
                                       }}
                                />
                                <ButtonComponent
                                    className="attachment-upload-button"
                                    disabled={orderAttachmentTitle?.length === 0 || orderAttachmentTitle.length > 100}
                                    color={"secondary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    size={'large'}
                                    startIcon={<UploadOutlinedIcon/>}
                                    handleClick={() => {
                                        orderAttachmentFileRef.current?.click()
                                    }}>
                                    Choose
                                </ButtonComponent>
                            </div>
                            <div className="attachment-list-section">
                                <>
                                    {orderAttachmentList?.length > 0 &&
                                        <div className="attachment-list-wrapper">
                                            {orderAttachmentList?.map((attachment: any) =>
                                                <div key={CommonService.getUUID()}>
                                                    <AttachmentViewDownloadComponent
                                                        attachment={attachment}
                                                        attachmentTitle={attachment?.title}
                                                        showDeleteOption={true}
                                                        onClick={(id: any) => handleAttachmentRemove(id, 'order')}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    }
                                    {(orderAttachmentList?.length === 0 || !orderAttachmentList) &&
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <FeedbackComponent>No attachment have been uploaded.</FeedbackComponent>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                            </Grid>
                                        </Grid>
                                    }
                                </>
                            </div>
                            <div className="attachment-section-header">Patient Attachments:</div>
                            <div className="attachment-input-wrapper">
                                <div className={'attachment-input-section'}>
                                    <InputComponent
                                        type={"text"}
                                        name={"title"}
                                        label={"Attachment Name"}
                                        placeholder={"Enter Attachment Name"}
                                        value={patientAttachmentTitle}
                                        onChange={(value: any) => {
                                            setPatientAttachmentTitle(value.replace(/\s/g, ''));
                                        }}
                                    />
                                    {
                                        patientAttachmentTitle.length > 100 &&
                                        <ErrorComponent errorText={'Attachment name should be less than 100 characters'}/>
                                    }
                                    <input type={"file"}
                                           className={"display-none"}
                                           ref={patientAttachmentFileRef}
                                           accept={"application/pdf,image/jpg, image/jpeg, image/png"}
                                           onChange={(event) => {
                                               handlePatientAttachmentUpload(event);
                                           }}
                                    />
                                </div>
                                <ButtonComponent
                                    className={'attachment-upload-button'}
                                    disabled={patientAttachmentTitle?.length === 0 || patientAttachmentTitle.length > 100}
                                    color={"secondary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    size={'large'}
                                    startIcon={<UploadOutlinedIcon/>}
                                    handleClick={() => {
                                        patientAttachmentFileRef.current?.click()
                                    }}>
                                    Choose
                                </ButtonComponent>
                            </div>

                            <div className="attachment-list-section">
                                {patientAttachmentList?.length > 0 &&
                                    <div className="attachment-list-wrapper">
                                        {patientAttachmentList?.map((attachment: any) =>
                                            <div key={CommonService.getUUID()} className={"attachment-list-item"}>
                                                <AttachmentViewDownloadComponent
                                                    attachment={attachment}
                                                    attachmentTitle={attachment?.title}
                                                    showDeleteOption={true}
                                                    onClick={(id: any) => handleAttachmentRemove(id, 'patient')}
                                                />
                                            </div>
                                        )}
                                    </div>
                                }
                                {(patientAttachmentList?.length === 0 || !patientAttachmentList) &&
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <FeedbackComponent>No attachment have been uploaded.</FeedbackComponent>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                        </Grid>
                                    </Grid>
                                }
                            </div>
                        </div>

                        <div className='form-action-section-edit'>
                            <ButtonComponent
                                className={'width-25'}
                                type="button"
                                color={"secondary"}
                                variant={"outlined"}
                                handleClick={() => {
                                   onEditCancel()
                                }}
                            >
                                Cancel
                            </ButtonComponent>
                            <ButtonComponent
                                className={"width-25"}
                                type="button"
                                color={"primary"}
                                variant={"contained"}
                                fullWidth={false}
                                handleClick={() => {
                                    onUpdateComplete({
                                        'order': orderAttachmentList, 'patient': patientAttachmentList
                                    });
                                }}
                                disabled={!isSaveButtonEnable}>
                                Save Changes
                            </ButtonComponent>
                        </div>
                    </form>
                </div>

                <DialogComponent open={showPatientAttachmentPreviewDialog}
                                 maxWidth={'md'}
                                 title={patientAttachmentTitle}
                                 isShowCancel={true}
                                 onClose={() => {
                                     setShowPatientAttachmentPreviewDialog(false);
                                     setPatientAttachmentTitle("");
                                 }}
                                 className={"attachment-preview-dialog"}>
                    <div className="attachment-preview-dialog-body" id="file_preview_component">
                        {patientAttachmentFile && patientAttachmentFile?.type === 'application/pdf' ?
                            <PdfPreviewComponent
                                attachmentFile={patientAttachmentFile}
                                width="850"
                                height="500"
                                isFile={isNewPatientAttachment}
                            />
                            :
                            <FilePreviewerComponent
                                attachmentFile={patientAttachmentFile}
                                attachmentUrl={patientAttachmentFile}
                                isFile={isNewPatientAttachment}/>
                        }
                    </div>
                    {patientAttachmentFile && <div className="uploaded-attachment-file-name">
                        <span className="font-weight-bold"> Uploaded File Name:</span>
                        <span>{patientAttachmentFile?.name}</span>
                    </div>
                    }
                    <div className="attachment-preview-dialog-footer">
                        <ButtonComponent variant={"outlined"}
                                         id="cancel_btn"
                                         fullWidth={true}
                                         disabled={isPatientAttachmentBeingUploaded}
                                         handleClick={() => {
                                             patientAttachmentFileRef.current?.click()
                                         }}
                        >
                            Re-upload
                        </ButtonComponent>&nbsp;
                        {
                            isContinueVisible &&
                            <ButtonComponent variant={"contained"}
                                             id="continue_btn"
                                             fullWidth={true}
                                             isLoading={isPatientAttachmentBeingUploaded}
                                             handleClick={onPatientAttachmentSubmit}>
                                Continue
                            </ButtonComponent>
                        }
                    </div>
                </DialogComponent>
                <DialogComponent open={showOrderAttachmentPreviewDialog}
                                 maxWidth={'md'}
                                 title={orderAttachmentTitle}
                                 isShowCancel={true}
                                 onClose={() => {
                                     setOrderAttachmentTitle("");
                                     setShowOrderAttachmentPreviewDialog(false)
                                 }}
                                 className={"attachment-preview-dialog"}>
                    <div className="attachment-preview-dialog-body" id="file_preview_component">
                        {orderAttachmentFile && orderAttachmentFile?.type === 'application/pdf' ?
                            <PdfPreviewComponent
                                attachmentFile={orderAttachmentFile}
                                width="850"
                                height="500"
                                isFile={isNewOrderAttachment}
                            />
                            :
                            <FilePreviewerComponent
                                attachmentFile={orderAttachmentFile}
                                isFile={isNewOrderAttachment}/>
                        }
                    </div>
                    {orderAttachmentFile && <div className="uploaded-attachment-file-name">
                        <span className="font-weight-bold"> Uploaded File Name:</span>
                        <span>{orderAttachmentFile?.name}</span>
                    </div>
                    }
                    <div className="attachment-preview-dialog-footer">
                        <ButtonComponent variant={"outlined"}
                                         id="cancel_btn"
                                         fullWidth={true}
                                         disabled={isOrderAttachmentBeingUploaded}
                                         handleClick={() => {
                                             orderAttachmentFileRef.current?.click()
                                         }}
                        >
                            Re-upload
                        </ButtonComponent>&nbsp;
                        {
                            isContinueVisible &&
                            <ButtonComponent variant={"contained"}
                                             id="continue_btn"
                                             fullWidth={true}
                                             isLoading={isOrderAttachmentBeingUploaded}
                                             handleClick={onOrderAttachmentSubmit}>
                                Continue
                            </ButtonComponent>
                        }
                    </div>
                </DialogComponent>
            </div>
        )
    }

;

export default TestOrderAttachmentsEditComponent;
